export const API_URL = 'https://qademo.ebslab.in/api';
export const API_URL_AUTH = 'https://auth.ebslab.in/api';

